module.exports = __webpack_public_path__ + "img/notification-bell-mobile-en.69a302f3.jpg";